import { Component, Type, ComponentFactoryResolver, ViewChild, OnDestroy, ComponentRef, AfterViewInit, ChangeDetectorRef, Inject, Injector, EventEmitter, Output } from '@angular/core';
import { InsertionDirective } from './insertion.directive';
import { Subject } from 'rxjs';
import { DialogRef, DialogModalSize } from './dialog-ref';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    standalone: false
})
export class DialogComponent implements AfterViewInit, OnDestroy {

  ModalSize = DialogModalSize;
  className:any;
  componentRef: ComponentRef<any>;
  data: any;
  size: any;
  title: any;
  closehide: any;
  // ref: DialogRef;
  @ViewChild(InsertionDirective)
  insertionPoint: InsertionDirective;

  private readonly _onClose = new Subject<any>();
  public onClose = this._onClose.asObservable();
  @Output() getData: EventEmitter<any> = new EventEmitter();//for outputting general configration

  childComponentType: Type<any>;
  selector: any;
  baseService:any

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private cd: ChangeDetectorRef, private dialogRef: DialogRef,@Inject(DOCUMENT) private document?: any) {
  }

  ngAfterViewInit() {
    if(this.selector){
      this.loadChildComponentBySelector(this.selector);
    }else{
      this.loadChildComponent(this.childComponentType);
    }
    
    this.cd.detectChanges();
  }

  onOverlayClicked(evt: MouseEvent) {
   //this.dialogRef.close();
  }

  onDialogClicked(evt: MouseEvent) {
    //evt.stopPropagation(); //fix #10325 to close the multiselect on outside click
  }

  loadChildComponent(componentType: Type<any>) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentType);

    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent(componentFactory);
  }


  loadChildComponentBySelector(selector) {
    let viewContainerRef = this.insertionPoint.viewContainerRef;
    viewContainerRef.clear();
    this.baseService.createComponent(selector,viewContainerRef,(cmp)=>{
      this.componentRef=cmp
      this.getData.emit({"type":"componentRef","obj":cmp})
    })
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  close() {
    this._onClose.next("");
  }
  onDialogClose(event) {
    this.dialogRef.close();
    if(document.getElementsByClassName('kx-cstm-popup-overlay').length == 1)
                this.document.body.classList.remove('modal-open');
  }
}
